import { render, staticRenderFns } from "./Panel.handler.vue?vue&type=template&id=e72faf46&"
import script from "./Panel.handler.vue?vue&type=script&lang=ts&"
export * from "./Panel.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports